import React, { createContext, useContext, useEffect, useState } from "react";
import { getDomainType, getDomainConfig, DOMAIN_TYPES } from "../utils/domain";

const DomainContext = createContext();

/**
 * Hook 來使用 Domain Context
 * @returns {object} domain 上下文數據
 */
export const useDomain = () => {
  const context = useContext(DomainContext);
  if (!context) {
    throw new Error("useDomain must be used within a DomainProvider");
  }
  return context;
};

/**
 * Domain Provider 組件
 * 提供 domain 相關的上下文數據給子組件
 */
export const DomainProvider = ({ children }) => {
  // 直接在初始化時獲取正確的 domain 類型，避免異步問題
  const [domainType, setDomainType] = useState(() => getDomainType());
  const [domainConfig, setDomainConfig] = useState(() =>
    getDomainConfig(getDomainType())
  );

  // 保留 useEffect 以防需要監聽變化（例如在 SPA 中切換 domain）
  useEffect(() => {
    const currentDomainType = getDomainType();
    const currentDomainConfig = getDomainConfig(currentDomainType);

    console.log("DomainProvider useEffect - Domain type:", currentDomainType);
    console.log(
      "DomainProvider useEffect - Domain config:",
      currentDomainConfig
    );

    setDomainType(currentDomainType);
    setDomainConfig(currentDomainConfig);
  }, []);

  const contextValue = {
    domainType,
    domainConfig,
    isDomainKor: domainType === DOMAIN_TYPES.KOR,
    isDomainDefault: domainType === DOMAIN_TYPES.DEFAULT,
    // 便利方法來獲取配置值
    getApiUrl: () => domainConfig.apiUrl,
    getRecaptchaKey: () => domainConfig.recaptchaKey,
    getContactEmail: () => domainConfig.contactEmail,
    getDefaultLanguage: () => domainConfig.defaultLanguage,
    getSupportedLanguages: () => domainConfig.supportedLanguages,
    getBrandName: () => domainConfig.brandName,
    getTheme: () => domainConfig.theme,
  };

  return (
    <DomainContext.Provider value={contextValue}>
      {children}
    </DomainContext.Provider>
  );
};
